import { render, staticRenderFns } from "./BuildKit.vue?vue&type=template&id=08ee2adf&"
import script from "./BuildKit.vue?vue&type=script&lang=js&"
export * from "./BuildKit.vue?vue&type=script&lang=js&"
import style0 from "./BuildKit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports